import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import { shouldUseHomeMockFallback } from "@/lib/devMockFallback";
import { getMockProjectList } from "@/mocks";
import type { PaginatedProjectListOutput, ProjectListParams } from "@/types";

export function useProjectList(params: ProjectListParams) {
  const query = buildParams({
    account_id: params.account_id,
    role: params.role,
    search: params.search,
    match_mode: params.match_mode,
    project_code: params.project_code,
    organization_id: params.organization_id,
    project_name: params.project_name,
    project_status: params.project_status,
    is_favorite: params.is_favorite,
    deadline_status: params.deadline_status,
    signatures_date: params.signatures_date,
    site_name: params.site_name,
    asset_names: params.asset_names,
    standard_acronym: params.standard_acronym,
    client_name: params.client_name,
    sort_dir: params.sort,
    page: params.page,
    page_size: params.page_size,
  });

  return useQuery({
    queryKey: ["project-list", params],
    queryFn: async () => {
      try {
        return await apiFetch<PaginatedProjectListOutput>(`/v1/home/project-list${query}`);
      } catch (error) {
        if (shouldUseHomeMockFallback()) {
          console.warn("Falling back to local Project list mock data in development.", error);
          return getMockProjectList(params);
        }

        throw error;
      }
    },
  });
}
